import {damsFetch} from "../app/damsFetch";
import {clientLog} from "../clientLog";

/**
 * Asks the backend to commit the search index once, so that models saved a moment ago are searchable.
 * The backend writes models to the index without committing (DE-1787), so callers that re-search right
 * after saving call this first. A failed commit is logged and swallowed: the caller re-searches anyway.
 * @returns {Promise<void>}
 */
export const commitIndex = async () => {
    try {
        await damsFetch("/index/commit", {method: "POST"});
    } catch (error) {
        clientLog("error", error.toString(), "commitIndex");
    }
};
